export default __webpack_public_path__ + "static/media/no-image-rect.4d569465.png";